import { inject, injectable } from "@launchtray/tsyringe-async";
import { Bindable, NotifyProperty, nameof } from "../../../../../../../shared/bindable-data";
import { IMarketplaceNewsModel } from "./IMarketplaceNewsModel";
import { MarketplaceNewsItem } from "./MarketplaceNewsItem";
import { INetworkClient } from "../../../../../../networking/INetworkClient";

@injectable()
export class MarketplaceNewsModel extends Bindable implements IMarketplaceNewsModel {
    public readonly news: NotifyProperty<MarketplaceNewsItem[]>;
    private readonly networkClient: INetworkClient;

    public constructor(
        @inject("INetworkClient") networkClient: INetworkClient
    ) {
        super();
        this.networkClient = networkClient;
        this.news = new NotifyProperty(this, nameof("news"), []);
    }

    public async loadMarketplaceNews(): Promise<void> {
        const marketplaceNewsDto = await this.networkClient.getMarketplaceNews();
        if (marketplaceNewsDto.items == undefined || ! (marketplaceNewsDto.items instanceof Array) ) {
            throw new Error("Failed to load Marketplace news items.");
        }
        const newsItems = new Array<MarketplaceNewsItem>();
        for (const itemDto of marketplaceNewsDto.items) {
            newsItems.push(new MarketplaceNewsItem(itemDto));
        }
        this.news.setValue(newsItems);
    }

}
